import { render } from "./ExistingShiftsList.vue?vue&type=template&id=354da67a&scoped=true"
import script from "./ExistingShiftsList.vue?vue&type=script&lang=js"
export * from "./ExistingShiftsList.vue?vue&type=script&lang=js"

import "./ExistingShiftsList.vue?vue&type=style&index=0&id=354da67a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354da67a"]])

export default __exports__